








































































import { isElectron } from '@/utils/electron'
import { Vue, Component, Emit, Prop, Ref } from 'vue-property-decorator'

@Component
export default class TeamRegistrationComplete extends Vue {
  @Prop({ required: true })
  readonly teamToken!: string

  @Ref('teamTokenTextField')
  readonly teamTokenTextField!: { $el: HTMLInputElement }

  @Ref('teamTokenUrlTextField')
  readonly teamTokenUrlTextField!: { $el: HTMLInputElement }

  @Prop({ type: Boolean, default: false }) readonly hideLfg!: boolean

  @Emit('close')
  onClose() {
    return this
  }

  toLookForGroup() {
    this.$router.push({ name: 'TournamentDetailsLFG' })
    this.onClose()
  }

  get teamTokenTrimmed() {
    return this.teamToken.replace(' ', '')
  }

  get teamTokenUrl() {
    if (this.isElectron) {
      return process.env.VUE_APP_TEAM_TOKEN_URL!.replace(
        '%teamToken%',
        this.teamTokenTrimmed
      )
    }
    return `${window.location.origin}/invite/${this.teamTokenTrimmed}`
  }

  get isElectron() {
    return isElectron()
  }

  copyTeamToken() {
    this.$copyText(this.teamTokenTrimmed, this.teamTokenTextField.$el).then(
      e => {
        this.$toast.info(
          this.$t('TeamRegistrationComplete.CopiedTeamCodeToClipboard')
        )
      },
      e => {
        this.$toast.error(
          this.$t('TeamRegistrationComplete.FailedToCopyToClipboard')
        )
      }
    )
  }

  copyTeamTokenUrl() {
    this.$copyText(this.teamTokenUrl, this.teamTokenUrlTextField.$el).then(
      e => {
        this.$toast.info(
          this.$t('TeamRegistrationComplete.CopiedTeamCodeToClipboard')
        )
      },
      e => {
        this.$toast.error(
          this.$t('TeamRegistrationComplete.FailedToCopyToClipboard')
        )
      }
    )
  }
}
